
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/base/SEOHead';

const BlogPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead 
        title="Safety Blog - HP Inc Consulting Services | Workplace Safety Insights & Tips"
        description="Expert insights on workplace safety, OSHA compliance, industrial hygiene, and safety training. Stay updated with the latest safety regulations and best practices from HP Inc Consulting Services."
        keywords="safety blog, workplace safety tips, OSHA compliance news, industrial hygiene insights, safety training articles, construction safety blog, safety regulations updates, workplace safety best practices"
        canonical="https://hpincconsultant.com/blog"
        ogTitle="Safety Blog - Expert Workplace Safety Insights"
        ogDescription="Stay informed with expert insights on workplace safety, OSHA compliance, and safety best practices from our professional safety consultants."
        ogUrl="https://hpincconsultant.com/blog"
      />
      <Header />
      <main>
        {/* Hero Section */}
        <section className="relative bg-gradient-to-r from-blue-900 to-blue-700 text-white py-20">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">
                Safety Blog
              </h1>
              <p className="text-xl mb-8">
                Latest insights and updates on workplace safety
              </p>
            </div>
          </div>
        </section>

        {/* Blog Section */}
        <section className="py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-6xl mx-auto">
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                <article className="bg-white border border-gray-200 rounded-lg overflow-hidden shadow-sm hover:shadow-lg transition-shadow duration-300">
                  <a href="https://threesixtysafety.com/changes-to-osha-in-2024/" target="_blank" rel="noopener noreferrer" className="block">
                    <img 
                      src="https://public.readdy.ai/ai/img_res/404958290b852446358c382529d869da.jpg"
                      alt="OSHA Regulations 2024"
                      className="w-full h-48 object-cover object-top"
                    />
                    <div className="p-6">
                      <h3 className="text-xl font-semibold mb-2 hover:text-blue-600 transition-colors">New OSHA Regulations for 2024</h3>
                      <p className="text-gray-600 mb-4">Stay updated with the latest OSHA regulatory changes and how they affect your business.</p>
                      <div className="text-sm text-gray-500">March 15, 2024</div>
                    </div>
                  </a>
                </article>
                
                <article className="bg-white border border-gray-200 rounded-lg overflow-hidden shadow-sm hover:shadow-lg transition-shadow duration-300">
                  <a href="https://www.osha.gov/sites/default/files/training-library_industrial_hygiene.pdf" target="_blank" rel="noopener noreferrer" className="block">
                    <img 
                      src="https://readdy.ai/api/search-image?query=Industrial%20hygiene%20specialist%20conducting%20air%20quality%20testing%20in%20manufacturing%20facility%20with%20professional%20monitoring%20equipment%20and%20safety%20gear%2C%20clean%20industrial%20environment%20with%20proper%20ventilation%20systems%20visible&width=400&height=240&seq=2&orientation=landscape"
                      alt="Industrial Hygiene Best Practices"
                      className="w-full h-48 object-cover object-top"
                    />
                    <div className="p-6">
                      <h3 className="text-xl font-semibold mb-2 hover:text-blue-600 transition-colors">Industrial Hygiene Best Practices</h3>
                      <p className="text-gray-600 mb-4">Essential practices for maintaining a healthy work environment and protecting employee health.</p>
                      <div className="text-sm text-gray-500">March 10, 2024</div>
                    </div>
                  </a>
                </article>
                
                <article className="bg-white border border-gray-200 rounded-lg overflow-hidden shadow-sm hover:shadow-lg transition-shadow duration-300">
                  <a href="https://businesscloud.co.uk/news/from-risk-to-roi-calculating-the-financial-impact-of-workplace-safety/" target="_blank" rel="noopener noreferrer" className="block">
                    <img 
                      src="https://readdy.ai/api/search-image?query=Professional%20safety%20training%20session%20with%20diverse%20group%20of%20construction%20workers%20wearing%20hard%20hats%20and%20safety%20vests%20learning%20about%20workplace%20safety%20protocols%2C%20modern%20training%20room%20with%20safety%20charts%20and%20equipment%20displays&width=400&height=240&seq=3&orientation=landscape"
                      alt="Safety Training ROI"
                      className="w-full h-48 object-cover object-top"
                    />
                    <div className="p-6">
                      <h3 className="text-xl font-semibold mb-2 hover:text-blue-600 transition-colors">Safety Training ROI</h3>
                      <p className="text-gray-600 mb-4">How investing in safety training can save your company money and protect your workforce.</p>
                      <div className="text-sm text-gray-500">March 5, 2024</div>
                    </div>
                  </a>
                </article>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default BlogPage;
